import {Dialog, DialogTitle, DialogContent, IconButton, Box, Button, DialogProps, alpha} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type ConfirmDialogProps = {
    open: boolean;
    title?: string;
    content: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    isLoading?: boolean;
    confirmColor?: string;
    onConfirm: () => void | Promise<void>;
    onClose: () => void;
} & Pick<DialogProps, 'fullWidth' | 'maxWidth'>;

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title = 'Подтверждение',
    content,
    confirmText = 'Подтвердить',
    cancelText = 'Отмена',
    isLoading,
    confirmColor,
    onConfirm,
    onClose,
    fullWidth = true,
    maxWidth = 'sm',
}) => (
    <Dialog open={open} onClose={onClose} fullWidth={fullWidth} maxWidth={maxWidth}>
        <Box sx={{p: '20px 24px 10px 3px', position: 'relative', backgroundColor: '#f5f7ff'}}>
            <DialogTitle sx={{pr: 5}}>{title}</DialogTitle>
            <IconButton onClick={onClose} sx={{position: 'absolute', right: 16, top: 16}}>
                <CloseIcon />
            </IconButton>
        </Box>

        <DialogContent>
            <Box display="flex" flexDirection="column" pb={1}>
                {content}
            </Box>
            <Box sx={{mt: 2, mb: 1}}>
                <Button
                    variant="contained"
                    onClick={() => void onConfirm()}
                    sx={{
                        mr: 2,
                        ...(confirmColor ? {backgroundColor: confirmColor, '&:hover': {backgroundColor: alpha(confirmColor, 0.8)}} : {}),
                    }}
                    disabled={isLoading}
                >
                    {confirmText}
                </Button>
                <Button variant="text" onClick={onClose}>
                    {cancelText}
                </Button>
            </Box>
        </DialogContent>
    </Dialog>
);
